export const icons = Object.freeze({
  arrowRight: 'fa-solid fa-arrow-right',
  check: 'fa-solid fa-check',
  checkCircle: 'fa-solid fa-circle-check',
  circle: 'fa-regular fa-circle',
  chevronDown: 'fa-solid fa-chevron-down',
  chevronLeft: 'fa-solid fa-chevron-left',
  chevronRight: 'fa-solid fa-chevron-right',
  email: 'fa-solid fa-envelope',
  webhook: 'fa-solid fa-code-branch',
  plug: 'fa-solid fa-plug',
  error: 'fa-solid fa-circle-exclamation',
  eye: 'fa-solid fa-eye',
  eyeSlash: 'fa-solid fa-eye-slash',
  google: 'fa-brands fa-google',
  key: 'fa-solid fa-key',
  lock: 'fa-solid fa-lock',
  logout: 'fa-solid fa-right-from-bracket',
  paperPlane: 'fa-solid fa-paper-plane',
  plus: 'fa-solid fa-plus',
  minus: 'fa-solid fa-minus',
  refresh: 'fa-solid fa-rotate',
  spinner: 'fa-solid fa-spinner',
  user: 'fa-solid fa-user',
  warning: 'fa-solid fa-triangle-exclamation',
  help: 'fa-solid fa-question',
  workspace: 'fa-solid fa-building',
  addUser: 'fa-solid fa-user-plus',
  close: 'fa-solid fa-xmark',
  forms: 'fa-solid fa-rectangle-list',
  removeUser: 'fa-solid fa-user-minus',
  team: 'fa-solid fa-users',
  archive: 'fa-solid fa-box-archive',
  back: 'fa-solid fa-arrow-left',
  copy: 'fa-solid fa-copy',
  edit: 'fa-solid fa-pen-to-square',
  ellipsis: 'fa-solid fa-ellipsis',
  grid: 'fa-solid fa-table-cells-large',
  list: 'fa-solid fa-list',
  rename: 'fa-solid fa-i-cursor',
  restore: 'fa-solid fa-arrow-rotate-left',
  search: 'fa-solid fa-magnifying-glass',
  trash: 'fa-solid fa-trash',
  arrowDown: 'fa-solid fa-arrow-down',
  arrowUp: 'fa-solid fa-arrow-up',
  clock: 'fa-solid fa-clock',
  cloud: 'fa-solid fa-cloud',
  contact: 'fa-solid fa-address-card',
  consent: 'fa-solid fa-scale-balanced',
  date: 'fa-solid fa-calendar-day',
  dropdown: 'fa-solid fa-circle-chevron-down',
  end: 'fa-solid fa-flag-checkered',
  gauge: 'fa-solid fa-gauge-high',
  longText: 'fa-solid fa-align-left',
  multipleChoice: 'fa-solid fa-square-check',
  number: 'fa-solid fa-hashtag',
  offline: 'fa-solid fa-wifi',
  palette: 'fa-solid fa-palette',
  preview: 'fa-solid fa-play',
  rating: 'fa-solid fa-star',
  save: 'fa-solid fa-floppy-disk',
  scale: 'fa-solid fa-chart-simple',
  shortText: 'fa-solid fa-minus',
  singleChoice: 'fa-solid fa-circle-dot',
  statement: 'fa-solid fa-quote-left',
  section: 'fa-solid fa-grip-lines',
  telephone: 'fa-solid fa-phone',
  upload: 'fa-solid fa-cloud-arrow-up',
  image: 'fa-solid fa-image',
  website: 'fa-solid fa-link',
  welcome: 'fa-solid fa-door-open',
  yesNo: 'fa-solid fa-toggle-on',
  grip: 'fa-solid fa-grip-vertical',
  menu: 'fa-solid fa-bars',
  redo: 'fa-solid fa-arrow-rotate-right',
  externalLink: 'fa-solid fa-arrow-up-right-from-square',
  font: 'fa-solid fa-font',
  qrCode: 'fa-solid fa-qrcode',
  logic: 'fa-solid fa-code-branch',
  responses: 'fa-solid fa-inbox',
  settings: 'fa-solid fa-gear',
  chart: 'fa-solid fa-chart-line',
  filter: 'fa-solid fa-filter',
  download: 'fa-solid fa-download',
  template: 'fa-solid fa-layer-group',
  undo: 'fa-solid fa-arrow-rotate-left',
  calendar: 'fa-solid fa-calendar-days',
});
